import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  PaymentCardModel,
  PaymentInfoModel,
  SPEIPaymentModel,
  SingleItemResponse,
} from '@core/models';
import { Api } from '@core/services/api.state';
import { ApiService } from '@core/services/api/api.service';
import { environment } from '@rcsa-frontend/environments/environment';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExternalPaymentSpeiService extends Api<SPEIPaymentModel> {
  override endpoint: string;

  constructor(
    protected override readonly apiService: ApiService<SPEIPaymentModel>,
    private http: HttpClient
  ) {
    super(apiService);
    this.endpoint = `${environment.apiUrl}/v1/external/payments/payment-management/spei/multiple`;
  }

  public multiplePayment(data: PaymentCardModel): Observable<PaymentInfoModel> {
    const params = JSON.stringify(data);
    return this.http
      .post<SingleItemResponse<SPEIPaymentModel>>(this.endpoint, params)
      .pipe(
        map((result) => {
          return result.data;
        })
      );
  }
  public printReference(id: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}/v1/external/payments/payment-management/spei/pdf/${id}`,
      {
        responseType: 'blob',
      }
    );
  }
}
